.categoryResults {
  display: block;

  .moreResultsLink {
    margin-top: 24px;
  }

  .noResults {
    padding: 0 24px;

    .phone &,
    .tablet & {
      padding: 0 16px;
    }
  }
}